export default __webpack_public_path__ + "static/media/point-blank.14c007e2.mp3";